module.exports = __webpack_public_path__ + "img/IMG-20200313-WA0017.2d51bf8f.jpg";